module.exports = __webpack_public_path__ + "static/media/Sample Design_Bag_3.5641bf47.jpg";